/**
 * @generated SignedSource<<8aa8be75cd52e6543c3f7297a504105b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JswProjectMenu$data = {
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly softwareBoardCount: AGG$Long | null | undefined;
  readonly subspaceCount?: AGG$Long | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"JswExpandableProject" | "JswNonExpandableProject">;
  readonly " $fragmentType": "JswProjectMenu";
};
export type JswProjectMenu$key = {
  readonly " $data"?: JswProjectMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"JswProjectMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "JswProjectMenu",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "softwareBoardCount"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": "subspaceCount",
              "kind": "ScalarField",
              "name": "subspaceCount_cse"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswNonExpandableProject"
    },
    {
      "kind": "FragmentSpread",
      "name": "JswExpandableProject"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "8b8dd3343b7311d77d7d4ddd4a12cbf3";

export default node;
